<template>
  <div class="login-container">
    <div class="login-box">
      <h2 class="title">Criar Senha</h2>
      <form @submit.prevent="handleSubmit">
        <div class="form-group">
          <input
            placeholder="Nova Senha (mín. 8 caracteres)"
            v-model="password"
            type="password"
            required
            :disabled="isLoading"
            class="input"
          />
        </div>
        <div class="form-group">
          <input
            placeholder="Confirmar Nova Senha"
            v-model="confirmPassword"
            type="password"
            required
            :disabled="isLoading"
            class="input"
          />
        </div>
        <button class="btn-login" type="submit" :disabled="isLoading" :class="{ 'loading': isLoading }">
          <span v-if="!isLoading">Confirmar Senha</span>
          <div v-else class="spinner-login"></div>
        </button>
      </form>
    </div>
    <AlertModal v-if="showModal" :message="modalMessage" @close="handleModalClose" />
  </div>
</template>

<script>
import '../../styles/Login.css';
import '../../styles/Global.css';
import requestV2 from '../../router/requestV2';
import AlertModal from '../../components/AlertModal.vue';

export default {
  name: 'DefinirSenha',
  components: { AlertModal },
  data() {
    return {
      password: '',
      confirmPassword: '',
      isLoading: false,
      showModal: false,
      modalMessage: '',
      token: '',
      isSuccess: false
    };
  },
  mounted() {
    this.token = this.$route.query.token;
    if (!this.token) {
      this.modalMessage = 'Token de redefinição não encontrado na URL.';
      this.showModal = true;
    }
  },
  methods: {
    handleModalClose() {
      this.showModal = false;
      this.modalMessage = '';
      if (this.isSuccess) {
        this.$router.push('/login');
      }
    },
    async handleSubmit() {
      if (!this.token) {
        this.modalMessage = 'Token inválido.';
        this.showModal = true;
        return;
      }

      if (this.password.length < 8) {
        this.modalMessage = 'A senha deve conter no mínimo 8 caracteres.';
        this.showModal = true;
        return;
      }

      if (this.password !== this.confirmPassword) {
        this.modalMessage = 'As senhas não coincidem.';
        this.showModal = true;
        return;
      }

      this.isLoading = true;

      try {
        await requestV2.post('/users/usuario/definir-senha', {
          token: this.token,
          password: this.password
        });

        this.modalMessage = 'Senha definida com sucesso!';
        this.isSuccess = true;
        this.showModal = true;
      } catch (err) {
        console.error(err);
        this.modalMessage = err.response?.data?.message || 'Erro ao definir a senha. Tente novamente.';
        this.showModal = true;
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>
